import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { HlmInput } from '@spartan-ng/helm/input';

/**
 * Field type `input` próprio (substitui o do @ngx-formly/primeng).
 * Suporta props.type: text (default) | url | number | password — os mesmos
 * usados pelo metadata-to-formly.mapper.
 */
@Component({
  selector: 'evolve-formly-input',
  imports: [ReactiveFormsModule, FormlyModule, HlmInput],
  template: `
    <input
      hlmInput
      class="w-full"
      [type]="inputType"
      [formControl]="formControl"
      [formlyAttributes]="field"
    />
  `,
})
export class InputFieldComponent extends FieldType<FieldTypeConfig> {
  get inputType(): string {
    return (this.props.type as string) || 'text';
  }
}
